import React, { useState } from "react";
import { Routes, Route, NavLink, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import OrganizationDetails from "./OrganizationDetails";
import UserDetails from "./UserDetails";
import TeamList from "./TeamList";
import Pricing from "./Pricing";
import Billing from "./Billing";
import ManageSubscription from "./ManageSubscription";

import Automation from "../setting2/Automation";
import ManageForms from "../setting2/ManageForms";
import ProcessDesigner from "../setting2/ProcessDesigner";
import MetaLeadsPage from "../home/metaleads/MetaLeadsPage";
import Uploads from "../home/Uploads";
import PipelinePermissions from "./PipelinePermissions";

export default function Settings() {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Hide navbar only on Billing page
  const hideNavbar = location.pathname.includes("billing");

  const [isWorkflowOpen, setIsWorkflowOpen] = useState(false);

  // Check if current path matches any workflow routes
  const isWorkflowActive = ["automation", "manage-forms", "process-designer"].some(path => location.pathname.includes(path));

  // Derive user role from stored userData (set at login/signup)
  const storedUserData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userRole = storedUserData?.role || "member"; // default to member
  const isManager = userRole === "manager" || userRole === "admin" || !!storedUserData?.isOrganizationCreated;

  return (
    <div style={ { margin: "0 auto", paddingTop: 0, paddingBottom: 24 } }>
      {/* Settings Navigation */ }
      { !hideNavbar && (
        <div style={ { marginBottom: 0 } }>
          <nav
            style={ {
              display: "flex",
              gap: 16,
              borderBottom: "1px solid #eee",
              paddingBottom: 8,
            } }
          >
            <NavLink
              to="/home/settings/profile"
              style={ ({ isActive }) => ({
                padding: "8px 16px",
                textDecoration: "none",
                color: isActive ? "#1976d2" : "#666",
                borderBottom: isActive ? "2px solid #1976d2" : "none",
                fontWeight: isActive ? "600" : "normal",
              }) }
            >
              Profile
            </NavLink>
            { isManager && (
              <NavLink
                to="/home/settings/facebook"
                style={ ({ isActive }) => ({
                  padding: "8px 16px",
                  textDecoration: "none",
                  color: isActive ? "#1976d2" : "#666",
                  borderBottom: isActive ? "2px solid #1976d2" : "none",
                  fontWeight: isActive ? "600" : "normal",
                }) }
              >
                Facebook
              </NavLink>
            ) }
            { isManager && (
              <NavLink
                to="/home/settings/uploads"
                style={({ isActive }) => ({
                  padding: "8px 16px",
                  textDecoration: "none",
                  color: isActive ? "#1976d2" : "#666",
                  borderBottom: isActive ? "2px solid #1976d2" : "none",
                  fontWeight: isActive ? "600" : "normal",
                })}
              >
                Uploads
              </NavLink>
            ) }
            { isManager && (
              <NavLink
                to="/home/settings/permissions"
                style={({ isActive }) => ({
                  padding: "8px 16px",
                  textDecoration: "none",
                  color: isActive ? "#1976d2" : "#666",
                  borderBottom: isActive ? "2px solid #1976d2" : "none",
                  fontWeight: isActive ? "600" : "normal",
                })}
              >
                Permissions
              </NavLink>
            ) }
            { isManager && (
              <NavLink
                to="/home/settings/pricing"
                style={ ({ isActive }) => ({
                  padding: "8px 16px",
                  textDecoration: "none",
                  color: isActive ? "#1976d2" : "#666",
                  borderBottom: isActive ? "2px solid #1976d2" : "none",
                  fontWeight: isActive ? "600" : "normal",
                }) }
              >
                Pricing & Plans
              </NavLink>
            ) }
            {/* { isManager && (
              <NavLink
                to="/home/settings/subscription"
                style={ ({ isActive }) => ({
                  padding: "8px 16px",
                  textDecoration: "none",
                  color: isActive ? "#1976d2" : "#666",
                  borderBottom: isActive ? "2px solid #1976d2" : "none",
                  fontWeight: isActive ? "600" : "normal",
                }) }
              >
                Manage Subscription
              </NavLink>
            ) } */}


            {/* <NavLink
              to="/home/manager"
              style={({ isActive }) => ({
                padding: "8px 16px",
                textDecoration: "none",
                color: isActive ? "#1976d2" : "#666",
                borderBottom: isActive ? "2px solid #1976d2" : "none",
                fontWeight: isActive ? "600" : "normal",
              })}
            >
              Manager View
            </NavLink> */}

          </nav>
        </div>
      ) }

      {/* Settings Content */ }
      <Routes>
        <Route index element={ <Navigate to="profile" replace /> } />
        <Route
          path="profile"
          element={
            <div
              style={ {
                display: "flex",
                gap: 24,
                flexWrap: "wrap",
                justifyContent: "flex-start",
                alignItems: "start",
              } }
            >
              <div style={ { flex: 1, minWidth: 260 } }>
                <UserDetails />
              </div>
            </div>
          }
        />
        <Route path="pricing" element={ isManager ? <Pricing /> : <Navigate to="profile" replace /> } />
        {/* <Route path="subscription" element={ isManager ? <ManageSubscription /> : <Navigate to="profile" replace /> } /> */}
        <Route path="billing" element={ isManager ? <Billing /> : <Navigate to="profile" replace /> } />

        {/* Workflow Routes */ }
        <Route path="automation" element={ <Automation /> } />
        <Route path="manage-forms" element={ <ManageForms /> } />
        <Route path="process-designer" element={ <ProcessDesigner /> } />
        <Route path="facebook" element={ isManager ? <MetaLeadsPage /> : <Navigate to="profile" replace /> } />
        <Route path="uploads" element={ isManager ? <Uploads /> : <Navigate to="profile" replace /> } />
        <Route path="permissions" element={ isManager ? <PipelinePermissions /> : <Navigate to="profile" replace /> } />
      </Routes>
    </div>
  );
}
